export const WAIT_FOR_INVALIDATION_MS = 700;
